import React, { useEffect, useState } from "react";

export const ApplyForArray = [
  { id: 1, name: "Accounts", alias: "ACCOUNTS" },
  { id: 2, name: "Account_Group", alias: "ACCOUNT_GROUP" },
  { id: 3, name: "Account_Type", alias: "ACCOUNT_TYPE" },
];

export const tdsHeader = [
  { id: 1, name: "S.no.", alias: "SNO" },
  { id: 2, name: "From Date", alias: "fromDate" },
  { id: 3, name: "To Date", alias: "toDate" },
  { id: 4, name: "Rule Name", alias: "ruleName" },
  { id: 5, name: "TDS Account", alias: "tdsAccountName" },
  { id: 6, name: "Action", alias: "" },
  // { id: 6, name: "", alias: "" },
];

export const debitCreditTDSHeader = [
  { id: 1, name: "S.No.", alias: "SNO" },
  { id: 2, name: "Ledger Acc", alias: "ledgerName" },
  { id: 3, name: "Ledger Type", alias: "ledgerType" },
  // { id: 4, name: "Amount Type", alias: "amountType" },
  // { id: 5, name: "Amount", alias: "amount" },
];

export const fillTDSHeader = [
  { id: 1, name: "S.No.", alias: "SNO" },
  { id: 2, name: "Deductee Type", alias: "deducteeType" },
  { id: 3, name: "With PAN(%)", alias: "withPanRate" },
  { id: 4, name: "Without PAN(%)", alias: "withoutPanRate" },
  { id: 5, name: "Non Filer(%)", alias: "nonFilerRate" },
  { id: 6, name: "Per Txn Threshold", alias: "perTxnThreshold" },
  { id: 7, name: "Annual Threshold", alias: "annualThreshold" },
];

export const dataStateTDS = [
  {
    id: 1,
    ruleName: "TDS on Professional Fees",
    ledgerType: "ACCOUNT_GROUP",
    fromDate: "2024-04-01",
    toDate: "2025-04-01",
    tdsAccountId: 101,
    tdsRate: 10.0,
    isDebit: true,
    permissionStateId: 1,
    isAvailable: true,
    createdAt: "2025-03-28T08:09:16.000+00:00",
    updatedAt: "2025-03-28T08:09:16.000+00:00",
    createdBy: 17112,
    updatedBy: 17112,
    partyLedgerMappings: [
      {
        id: 1,
        tdsRuleId: 1,
        ledgerType: "ACCOUNTS",
        ledgerId: 5001,
        isActive: null,
        amountType: "EQUALSANDGREATERTHAN",
        amount: 30000.0,
        permissionStateId: 2,
        isAvailable: true,
        createdAt: "2025-03-28T08:09:16.000+00:00",
        updatedAt: "2025-03-28T08:09:16.000+00:00",
        createdBy: 17112,
        updatedBy: 17112,
      },
    ],
    expenseLedgerMappings: [
      {
        id: 1,
        tdsRuleId: 1,
        ledgerType: "ACCOUNT_GROUP",
        ledgerId: 2001,
        amountType: "EQUALSANDGREATERTHAN",
        amount: 50000.0,
        isAnd: false,
        isActive: null,
        permissionStateId: 2,
        isAvailable: true,
        createdAt: "2025-03-28T08:09:16.000+00:00",
        updatedAt: "2025-03-28T08:09:16.000+00:00",
        createdBy: 17112,
        updatedBy: 17112,
      },
    ],
  },
];

export const fillTDSHeaders = [
  { id: 1, name: "S.No", alias: "SNO", textAlign: "center", width: "40px" },
  {
    id: 2,
    name: "Account",
    alias: "account",
    textAlign: "center",
    width: "15vh",
  },
  {
    id: 3,
    name: "Amount Type",
    alias: "amountType",
    textAlign: "center",
    width: "80px",
  },
  {
    id: 4,
    name: "Deductee Type",
    alias: "deducteeType",
    textAlign: "center",
    width: "80px",
  },
  {
    id: 5,
    name: "With PAN",
    alias: "withPanRate",
    textAlign: "right",
    width: "100px",
  },
  {
    id: 6,
    name: "Without PAN",
    alias: "withoutPanRate",
    textAlign: "right",
    width: "100px",
  },
  {
    id: 7,
    name: "Non Tax Filer",
    alias: "nonFilerRate",
    textAlign: "right",
    width: "100px",
  },
  {
    id: 8,
    name: "Per Txn Threshold",
    alias: "perTxnThreshold",
    textAlign: "right",
    width: "100px",
  },
  {
    id: 9,
    name: "Annual Threshold",
    alias: "annualThreshold",
    textAlign: "right",
    width: "100px",
  },
  // {
  //   id: 10,
  //   name: "Ranking",
  //   alias: "priority",
  //   textAlign: "center",
  //   width: "100px",
  // },
  {
    id: 10,
    name: "Action",
    alias: "action",
    textAlign: "center",
    width: "40px",
  },
];
